import * as React from "react";
const SvgDisk = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M1.5 7.99992V9.83325C1.5 11.2334 1.5 11.9334 1.77248 12.4682C2.01217 12.9386 2.39462 13.3211 2.86502 13.5608C3.3998 13.8333 4.09987 13.8333 5.5 13.8333H12.5C13.9001 13.8333 14.6002 13.8333 15.135 13.5608C15.6054 13.3211 15.9878 12.9386 16.2275 12.4682C16.5 11.9334 16.5 11.2334 16.5 9.83325V7.99992M1.5 7.99992H4.5621C4.96975 7.99992 5.17357 7.99992 5.36539 8.04597C5.53545 8.0868 5.69802 8.15414 5.84714 8.24552C6.01534 8.34859 6.15946 8.49272 6.44772 8.78097L6.55229 8.88554C6.84054 9.17379 6.98466 9.31792 7.15286 9.42099C7.30198 9.51237 7.46455 9.57971 7.63461 9.62054C7.82643 9.66659 8.03025 9.66659 8.4379 9.66659H9.5621C9.96975 9.66659 10.1736 9.66659 10.3654 9.62054C10.5354 9.57971 10.698 9.51237 10.8471 9.42099C11.0153 9.31792 11.1595 9.17379 11.4477 8.88554L11.5523 8.78097C11.8405 8.49272 11.9847 8.34859 12.1529 8.24552C12.302 8.15414 12.4646 8.0868 12.6346 8.04597C12.8264 7.99992 13.0303 7.99992 13.4379 7.99992H16.5M1.5 7.99992L3.43866 3.69179C3.82294 2.83783 4.01508 2.41085 4.31688 2.09788C4.58367 1.82122 4.91065 1.6098 5.27242 1.48004C5.68168 1.33325 6.1499 1.33325 7.08634 1.33325H10.9137C11.8501 1.33325 12.3183 1.33325 12.7276 1.48004C13.0893 1.6098 13.4163 1.82122 13.6831 2.09788C13.9849 2.41085 14.1771 2.83783 14.5613 3.69179L16.5 7.99992",
      stroke: "#01653A",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgDisk;
